<template>
    <div class="factory-set">
        <div class="actions">
            <div class="box">
                <div class="actions-func">
                    <Input v-model="conditions.name" :placeholder="$t('tagName')" style="width:200px;" class="margin-r10 shadow112006"/>
                    <Button type="info" icon="md-search" @click="search" class="shadow112006">{{$t('search')}}</Button>
                </div>
                <div class="btns" v-if="$store.state.user.rank==1">
                    <Button type="primary" icon="md-add" @click="addModal.show = true" class="margin-r10 shadow112006">{{$t('addTag')}}</Button>
                    <Button type="error" icon="md-trash" @click="delModal = true" class="shadow112006">{{$t('a_deleteTag')}}</Button>
                </div>
            </div>
        </div>
        <!-- table -->
        <Table border stripe ref="selection" :columns="columns" :data="factories" height="873" @on-selection-change="selectItem"/>
        <!-- 底部分页 -->
        <FactoryFooter isShowPage :page="page" :pageSizeOptions="[18, 36, 72]" @change-page="changePage" @change-page-size="changePageSize"></FactoryFooter>
        <!-- 添加车间 -->
        <Modal v-model="addModal.show" @on-ok="doAdd" @on-cancel="addModal.show = false" :ok-text="$t('ok')" :cancel-text="$t('cancel')" width="350">
            <p slot="header">
                <Icon type="md-add"/>
                <span>{{$t('addTag')}}</span>
            </p>
            <Form :model="addModal" :label-width="80">
                <FormItem :label="$t('tagName')">
                    <Input v-model="addModal.name" :placeholder="$t('tagName')"/>
                </FormItem>
                <FormItem :label="$t('a_tagSort')" style="margin-bottom:0px;">
                    <InputNumber v-model="addModal.sort" :placeholder="$t('a_tagSort')" :precision="0" style="width:100%;"/>
                </FormItem>
            </Form>
        </Modal>
        <!-- 编辑车间 -->
        <Modal v-model="editModal.show" @on-ok="doEdit" @on-cancel="editModal.show = false" :ok-text="$t('ok')" :cancel-text="$t('cancel')" width="350">
            <p slot="header">
                <Icon type="md-settings"/>
                <span>{{$t('editTag')}}</span>
            </p>
            <Form :model="editModal" :label-width="80">
                <FormItem :label="$t('tagName')">
                    <Input v-model="editModal.params.name" :placeholder="$t('tagName')"/>
                </FormItem>
                <FormItem :label="$t('a_tagSort')" style="margin-bottom:0px;">
                    <InputNumber :min="0" v-model="editModal.params.sort" :placeholder="$t('a_tagSort')" :precision="0" style="width:100%"/>
                </FormItem>
            </Form>
        </Modal>
        <!-- 删除车间 -->
        <Modal v-model="delModal" @on-ok="doDel" @on-cancel="delModal = false" :ok-text="$t('ok')" :cancel-text="$t('cancel')" width="350">
            <p slot="header">
                <Icon type="md-trash"/>
                <span>{{$t('a_deleteTag')}}</span>
            </p>
            <p>{{$t('a_deleteTagWaring')}}</p>
        </Modal>
    </div>
</template>
<script>
import FactoryFooter from '@/views/main_components/footer.vue';
import Axios from 'axios';
import AxiosUrl from '@/axiosurl.js';
import Moment from 'moment';

export default {
    components: {
        FactoryFooter
    },
    data() {
        // table字段
        var columns = [
            {
                type: 'selection',
                width: 60,
                align: 'center'
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('tagName'));
                },
                key: 'name',
                align: 'center'
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('addTime'));
                },
                key: 'created',
                align: 'center'
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('updateTime'));
                },
                key: 'updated',
                align: 'center'
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('action'));
                },
                align: 'center',
                width: 200,
                render: (h, params) => {
                    return h(
                        'i-button',
                        {
                            props: {
                                type: 'primary'
                            },
                            on: {
                                click: () => {
                                    this.editModal.params = Object.assign({}, params.row);
                                    this.editModal.show = true;
                                }
                            }
                        },
                        this.$t('edit')
                    );
                }
            }
        ];
        if (this.$store.state.user.rank != 1) {
            columns.pop();
        }
        return {
            columns,
            addModal: {
                show: false,
                name: '', // 车间名称
                sort: 1 //车间排序
            },
            editModal: {
                show: false,
                params: {}
            },
            delModal: false,
            // 查询信息
            conditions: {
                page: 1,
                size: 18,
                cid: this.$store.state.user.cid,
                name: '' // 车间名称
            },
            // 分页
            page: {
                page: 1, // 当前页数
                total: 0, // 总数
                size: 18 // 每页数量
            },
            factories: [], // 工厂列表
            checkItems: [] //多选列表
        };
    },
    created() {
        this.$store.commit('upNavbar', 9);
    },
    mounted() {
        this.getFactories();
    },
    methods: {
        // 获取车间列表信息
        getFactories() {
            Axios.get(AxiosUrl.workshop.list, {
                params: this.conditions
            }).then(res => {
                if (res.data.code == 200) {
                    this.page.total = res.data.data.total;
                    this.page.page = res.data.data.page;
                    let list = res.data.data.list;
                    list.forEach(item => {
                        item.created = Moment(item.created).format("YYYY-MM-DD HH:mm:ss");
                        item.updated = Moment(item.updated).format("YYYY-MM-DD HH:mm:ss");
                    })
                    this.factories = list;
                }
            });
        },
        // 改变页数
        changePage(page) {
            this.conditions.page = page;
            this.getFactories();
        },
        // 改变每页数量
        changePageSize(size) {
            this.conditions.size = size;
            this.getFactories();
        },
        // 多选选择
        selectItem(selections) {
            this.checkItems = [];
            for (let item of selections) {
                this.checkItems.push(item.ws_id);
            }
        },
        // 确认添加
        doAdd() {
            Axios.get(AxiosUrl.workshop.add, {
                params: {
                    cid: this.$store.state.user.cid,
                    name: this.addModal.name,
                    sort: this.addModal.sort
                }
            }).then(res => {
                if (res.data.code == 200) {
                    this.$Message.success(this.$t('addSuccess'));
                    this.conditions.page = 1; // 回到第一页
                    this.addModal.name = '';
                    this.addModal.sort = 1;
                    this.getFactories();
                } else {
                    this.$Message.error(res.data.msg);
                }
            });
        },
        // 查询
        search() {
            this.getFactories();
        },
        //删除所选中的工程
        doDel() {
            if (!this.checkItems.length) {
                this.$Message.error(this.$t('delSelectEmpty'));
                return;
            }
            Axios.get(AxiosUrl.workshop.del, {
                params: {
                    ws_ids: this.checkItems.join('-')
                }
            }).then(res => {
                if (res.data.code == 200) {
                    this.$Message.success(this.$t('deleteSuccess'));
                    this.getFactories();
                } else {
                    this.$Message.error(res.data.msg);
                }
            });
        },
        // 确认编辑
        doEdit() {
            Axios.get(AxiosUrl.workshop.edit, {
                params: {
                    ws_id: this.editModal.params.ws_id,
                    name: this.editModal.params.name,
                    sort: this.editModal.params.sort
                }
            }).then(res => {
                if (res.data.code == 200) {
                    this.$Message.success(this.$t('updateSuccess'));
                    this.getFactories();
                } else {
                    this.$Message.error(res.data.msg);
                }
            });
        }
    }
};
</script>
<style lang="less">
.factory-set {
    .ivu-input-number {
        width: 100%;
    }
}
</style>




// WEBPACK FOOTER //
// src/views/system/factoryManage.vue